/**
 * @Description: 销售订单字段
 * @Author: 菩萨蛮
 * @Date: 2021/3/29 2:58 下午
 * @Version v1.0.0
 *
 * 公司的业务千篇一律，复杂的代码好几百行。
 */
import moment from 'moment';
import OrderBase from '../OrderBase';

const today = moment().format('yyyy-MM-DD');

const SaleOrder = {
  ...OrderBase,
  id: { visible: false },
  saleOrderNo: { title: '订单编号', search: true, sort: 1, style: { width: '220px'} },
  type: {
    title: '订单类型',
    type: 'select',
    selectList: [
      { label: '大货', value: '大货' },
      { label: '试样', value: '试样' }
    ],
    defaultValue: '大货',
    search: true,
    isShow: true,
    style: { width: '100px' },
    sort: 2
  },
  goodsNo: {
    title: '物品编号',
    search: true,
    sort: 3,
    style: { width: '200px'}
  },
  mainQuantity: {
    title: '数量(单位)',
    sort: 4,
    style: { width: '120px'}
  },
  deliveryQuantity: {
    title: '已发货数量',
    sort: 5,
    style: { width: '120px'}
  },
  currencyUnit: {
    title: '结算币种',
    type: 'select',
    selectList: [
      { label: '人民币', value: '人民币' },
      { label: '美元', value: '美元' },
      { label: '欧元', value: '欧元' },
      { label: '日元', value: '日元' },
      { label: '英镑', value: '英镑' },
      { label: '港币', value: '港币' },
      { value: '法郎', label: '法郎' }
    ],
    defaultValue: '人民币',
    search: false,
    isShow: false,
    sort: 6
  },
  placeOrderDate: {
    title: '下单日期',
    // search: true,
    // isShow: true,
    // defaultValue: today,
    // type: 'date',
    style: { width: '110px' },
    sort: 7
  },
  deliveryTime: { title: '交期', style: { width: '110px' }, sort: 8 },
  remark: { title: '备注', visible: false },
};

export default SaleOrder;
